// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem } from '@/components';
import { Button } from '@/ui';
import FileUpload from '../FileUpload/FileUpload';
import { StyledButtons, StyledMessage } from './ImportFaqFormStyles';

// Helpers
import { useGetRequiredRule } from '@/hooks';
import { FaqImportFieldsNames, TFaqImportFormValues } from '../../helpers';

type TImportFaqFormProps = {
  onSubmit: (values: TFaqImportFormValues) => void;
  isLoading?: boolean;
};

const ImportFaqForm: FC<TImportFaqFormProps> = ({ onSubmit, isLoading }) => {
  const { t } = useTranslation(['common', 'validations']);
  const requiredRule = useGetRequiredRule({ t });

  return (
    <>
      <StyledMessage>{t('faq_import_description')}</StyledMessage>
      <Form onFinish={onSubmit}>
        <FormItem name={FaqImportFieldsNames.FILE} label={t('label_import_file')} rules={[requiredRule]}>
          <FileUpload />
        </FormItem>
        <StyledButtons>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {t('btn_faqs_import_start')}
          </Button>
        </StyledButtons>
      </Form>
    </>
  );
};

export default ImportFaqForm;
